const MAP_LAYER = {
    OPEN_STREET_MAP: 'openStreetMap',
    GOOGLE_MAPS: 'googleMaps',
    GOOGLE_HYBRID: 'googleHybrid',
    GOOGLE_SATELLITE: 'googleSatellite',
};
export default MAP_LAYER;
